import { Collapse, Icon } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { SectionTitle } from '../../../components/text';

import { SectionScheduleGetResponse } from '../types';
import SectionScheduleForm from './SectionScheduleForm';
import SectionShowSchedule from './SectionShowSchedule';

const SectionSchedules = ({
  data,
  onRefresh,
}: {
  data: SectionScheduleGetResponse;
  onRefresh: () => void;
}) => {
  /**
   * Se obtienen las opciones de los selects y
   * la información de periodo para realizar las validaciones de fechas
   */
  const options = useMemo(() => {
    const scheduleModules = data.timeModules;
    const scheduleLegends = data.activities;

    return {
      scheduleModules,
      scheduleLegends,
    };
  }, [data]);

  const { t } = useTranslation();
  const prefix = 'sectionsMaintainer.update';

  return (
    <Row className="mt-4">
      <Col xs={12}>
        <SectionTitle text={t(`${prefix}.classesSection`)} />
      </Col>
      <Col xs={12} className="mb-5">
        <p className="fs-16">{t(`${prefix}.classesSectionDescription`)}</p>
      </Col>

      <Col xs={12}>
        <div
          className="d-flex justify-content-between align-items-center bg-primary text-white px-4 py-3"
          style={{
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
          }}
        >
          <span className="fw-bold">Concepto</span>
          <span className="fs-14">Ver más</span>
        </div>

        <Collapse
          renderTitle={() => (
            <p className="fs-14 fw-600 my-auto ml-1 text-dark">Clases</p>
          )}
          headerStyles={{
            backgroundColor: '#fff',
            height: 60,
            paddingLeft: '1.5rem',
            paddingRight: '1.5rem',
          }}
          contentClassName="pt-3 border-left border-right border-bottom border-light"
          renderBtn={({ isOpened, toggle }) => (
            <div onClick={toggle} className="cursor-pointer mr-3">
              <Icon name={isOpened ? 'chevron_up' : 'chevron_right'} />
            </div>
          )}
        >
          <SectionScheduleForm data={data} onSave={onRefresh} />
        </Collapse>

        <Collapse
          renderTitle={() => (
            <p className="fs-14 fw-600 my-auto ml-1 text-dark">Horario</p>
          )}
          headerStyles={{
            backgroundColor: '#f8f9fa',
            height: 60,
            paddingLeft: '1.5rem',
            paddingRight: '1.5rem',
            borderBottomLeftRadius: 8,
            borderBottomRightRadius: 8,
          }}
          contentClassName="pt-3 border-left border-right border-bottom border-light"
          renderBtn={({ isOpened, toggle }) => (
            <div onClick={toggle} className="cursor-pointer mr-3">
              <Icon name={isOpened ? 'chevron_up' : 'chevron_right'} />
            </div>
          )}
        >
          <SectionShowSchedule
            section={data.section}
            sectionSchedules={data.section.sectionSchedules.filter(
              (schedule) => !schedule.deletedAt,
            )}
            modules={options.scheduleModules}
            legends={options.scheduleLegends}
          />
        </Collapse>
      </Col>
    </Row>
  );
};

export default SectionSchedules;
